var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "imdan8a5za",
    d: "M4 0h24c2.21 0 4 1.79 4 4v24c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179 -112) translate(179 112)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#EDF2F8",
    opacity: 0.8,
    xlinkHref: "#imdan8a5za"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0A8CE0",
    d: "M2.4 0h16.8c1.325 0 2.4 1.075 2.4 2.4v4.8c0 1.325-1.075 2.4-2.4 2.4H2.4C1.075 9.6 0 8.525 0 7.2V2.4C0 1.075 1.075 0 2.4 0z",
    transform: "translate(-179 -112) translate(179 112) translate(5 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M4.216 7.345c1.086 0 1.733-.615 1.733-1.694V2.167H4.887v3.477c0 .51-.239.784-.682.784-.4 0-.668-.27-.675-.682H2.5c0 .97.679 1.6 1.716 1.6zM10.154 2.167c1.04 0 1.758.693 1.758 1.737 0 1.04-.742 1.736-1.811 1.736h-.95v1.6H8.09V2.167zm-.282.84h-.72v1.804h.717c.608 0 .963-.324.963-.904 0-.576-.351-.9-.96-.9zM15.422 7.328c1.414 0 2.25-.837 2.25-2.218v-.574h-2.137v.774h1.104l-.004.08c-.02.63-.502 1.055-1.195 1.055-.844 0-1.378-.671-1.378-1.771 0-1.08.503-1.716 1.34-1.716.572 0 1.005.316 1.16.847h1.065c-.151-1.026-1.044-1.726-2.23-1.726-1.49 0-2.418.984-2.418 2.609 0 1.648.928 2.64 2.443 2.64z",
    transform: "translate(-179 -112) translate(179 112) translate(5 19)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#59709B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15-.5c.69 0 1.315.28 1.768.732C17.22.685 17.5 1.31 17.5 2h0v7c0 .69-.28 1.315-.732 1.768-.453.452-1.078.732-1.768.732h0H3c-.69 0-1.315-.28-1.768-.732C.78 10.315.5 9.69.5 9h0V2c0-.69.28-1.315.732-1.768C1.685-.22 2.31-.5 3-.5h0z",
    transform: "translate(-179 -112) translate(179 112) translate(7 5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.603 9.808L6.682 4 10.495 8.444 13.462 6.193 17.235 9.255M13.5 3.75c0-.966-.784-1.75-1.75-1.75S10 2.784 10 3.75",
    transform: "translate(-179 -112) translate(179 112) translate(7 5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJpg);
export default __webpack_public_path__ + "static/media/ic-jpg.1ac5b24f0ce4e3b997cafb1eaefe5abd.svg";
export { ForwardRef as ReactComponent };